import mobileCheck from 'dibs-client-check/dist/mobileCheck';
import Cookies from 'js-cookie';
import { deepLinkSupported } from '../../../mobileAds/helpers/deeplink';
import { isPlaReferrer } from './referrerHelper';
const hasInterstitualCookie = () => Cookies.getJSON().dibsMobileInterstitial || undefined;

export const shouldShowAd = () => {
    const isAppPage = mobileCheck.iPhone() && !hasInterstitualCookie() && deepLinkSupported();
    return isAppPage && !isPlaReferrer();
};



// WEBPACK FOOTER //
// ./src/notificationQueue/globalNotifications/helpers/mobileAdsHelper.js